import { render, staticRenderFns } from "./SitesAndDepots.vue?vue&type=template&id=58066656&"
import script from "./SitesAndDepots.vue?vue&type=script&lang=js&"
export * from "./SitesAndDepots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58066656')) {
      api.createRecord('58066656', component.options)
    } else {
      api.reload('58066656', component.options)
    }
    module.hot.accept("./SitesAndDepots.vue?vue&type=template&id=58066656&", function () {
      api.rerender('58066656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/SitesAndDepots.vue"
export default component.exports